import * as React from 'react';
import { ICorpusDocument } from '../../../../models/ICorpusDocument';
import Box from '@mui/material/Box';
import { TreeView } from '@mui/x-tree-view/TreeView';
import { TreeItem, TreeItemProps } from '@mui/x-tree-view/TreeItem';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { CorpuseDocumentItem, CorpuseDocumentItemProps } from '../CorpuseDocumentItem/CorpuseDocumentItem';
import { memo, useEffect, useMemo } from 'react';
import { getAllElementIds, getNodeUiId, makeCorpusTree } from '../corpusTreeHelpers';
import { ICorpusTree } from '../../../../models/ICorpusTree';


const renderTree = (node: ICorpusTree, onClick) => {
    const nodeId = getNodeUiId(node);
    return <TreeItem
        key={nodeId}
        nodeId={nodeId}
        className={node.id === 'root' ? 'hidden-root' : ''}
        label={
            node.children?.length > 0 ? node.url :
                <CorpuseDocumentItem
                    url={node.fullUrl}
                    id={nodeId}
                    name={node.url}
                    mimeType={node.mimeType}
                    lineIdx={node.lineIdx}
                    content={node.content}
                    onClick={onClick}
                />
        }
    >
        {Array.isArray(node.children)
            ? node.children.map((node) => renderTree(node, onClick))
            : null}
    </TreeItem>;
};

function getDefaultExpandedIds(tree, maxLevel = 8) {
    const result = [];
    getAllElementIds(tree, 1, maxLevel, result);

    return ['root', ...result];

}

type CorpusDocumentsTreeProps = {
    documents: ICorpusDocument[],
    onClick
    selectedDocument
    documentUpdateTs
    autoExpandDepth?: number
}

function CorpusDocumentsTree({
    selectedDocument,
    documents,
    documentUpdateTs,
    onClick,
    autoExpandDepth
}: CorpusDocumentsTreeProps) {

    const data = makeCorpusTree(documents) as ICorpusTree;

    const defaultExpanded = useMemo(() => {
        return selectedDocument ? getDefaultExpandedIds(data, autoExpandDepth) : [];
    }, [data, selectedDocument, autoExpandDepth]);

    useEffect(() => {
        if (selectedDocument) {
            const selDocTreeitem = document.querySelector(`a.corpus-document-item__url[href="${selectedDocument.url}"]`);
            if (selDocTreeitem) {
                selDocTreeitem.scrollIntoView({ block: 'center' });
            }
        }
    }, [selectedDocument]);

    return (
        <Box sx={{ minHeight: 110, flexGrow: 1, minWidth: 200 }}>
            <TreeView
                key={documentUpdateTs}
                defaultExpanded={defaultExpanded}
                defaultSelected={[selectedDocument?.id]}
                defaultCollapseIcon={<ExpandMoreIcon />}
                defaultExpandIcon={<ChevronRightIcon />}
            >
                {renderTree(data, onClick)}
            </TreeView>
        </Box>
    );
}

export default memo(CorpusDocumentsTree);
